"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ErrorTemplateBody = _interopRequireDefault(require("./ErrorTemplateBody"));
var MaintenancePage = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var edsContext = props.edsContext;
  var errorTitle = edsContext.formatMessage('component.ErrorPage.maintenance');
  var errorMessage = edsContext.formatMessage('component.ErrorPage.maintenance.message');
  return /*#__PURE__*/_react.default.createElement(_ErrorTemplateBody.default, (0, _extends2.default)({
    largeIllustrationName: props.narrow ? '503Narrow.png' : '503.png',
    errorTitle: errorTitle,
    errorMessage: errorMessage
  }, props, {
    ref: ref
  }));
});
MaintenancePage.displayName = 'MaintenancePage';
MaintenancePage.propTypes = {
  edsContext: _propTypes.default.object,
  narrow: _propTypes.default.bool
};
var _default = MaintenancePage;
exports.default = _default;